(function () {
  'use strict';

  /* @ngdoc object
   * @name teams.newTeam
   * @description
   *
   */
  angular
  .module('neo.home.teams.newTeam', [
    'ui.router'
  ]);
}());
